import getAccountDataLogic from "./getAccountData";
export default [...getAccountDataLogic];
